import React from "react";
import { labelUtils } from "../Util";
import FormGroupWrapper from "./FormGroupWrapper";
import store, { rootReducer } from "../../../../store";
import { setRendererFormState } from "../../../../slices/common/reducer";
import { useEffect } from "react";

const CustomDate = ({
  arrEle,
  newElfromJSON,
  fieldEle,
  formState,
  displayLabelKey,
  databaseKey,
  showRequired = true,
}) => {
  let key = databaseKey ? databaseKey : displayLabelKey;
  const today = new Date().toISOString().split("T")[0];
  const displayYes = fieldEle?.["display-yes"];
  const parentSelectedValue = displayYes ? formState[displayYes] : "";


  const getValue = (key) => {
    console.log(key);
    if (key === "upload_date") {
      const value = formState?.files?.policycopy_media_id?.created_date || formState[key];
      return value ? value.split("T")[0] : "";
    }
    if (key === "modified_date") {
      const value = formState?.files?.policycopy_media_id?.modified_date || formState[key];
      return value ? value.split("T")[0] : "";
    }
    return formState[key];
  };


  const shouldDisplay = parentSelectedValue?.toLowerCase() === "renewal";

  useEffect(() => {
    if (displayYes && shouldDisplay === false) {
      rootReducer.dispatch(
        setRendererFormState({ key: databaseKey, value: "" })
      );
    }
  }, [displayYes, shouldDisplay, databaseKey]);

  if (displayYes && !shouldDisplay) {
    return null;
  }

  return (
    <FormGroupWrapper
      arrEle={arrEle}
      newElfromJSON={newElfromJSON}
      fieldEle={fieldEle}
    >
      <div
        className="form-builder-element"
        style={{ width: labelUtils.getElementWidth(fieldEle) }}
      >
        <div className="date">
          <input
            type="date"
            id={newElfromJSON}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
              }
            }}
            placeholder={fieldEle?.["display-placeholder"]}
            disabled={fieldEle?.["display-disabled"] === 1}
            className="form-control custom-datepicker mandatory"
            autoComplete="off"
            required={
              showRequired ? fieldEle?.["display-required"] === 1 : false
            }
            name={key}
            min={fieldEle?.["allowFutureDates"] === 1 ? today : undefined}
            max={fieldEle?.["allowFutureDates"] === 0 ? today : undefined}
            value={getValue(key)}
            // onChange={(e) =>
            //   rootReducer.dispatch(
            //     setRendererFormState({ key, value: e.target.value })
            //   )
            // }
            onChange={(e) => {
              const inputValue = e.target.value;
              const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
              if (dateRegex.test(inputValue)) {
                rootReducer.dispatch(
                  setRendererFormState({ key, value: inputValue })
                );
              }
            }}
          />
          <span className="input-group-addon d-none">
            <i className="fa fa-calendar"></i>
          </span>
          <div className="invalid-feedback">This field is required</div>
          {fieldEle?.["display-description"] && (
            <div className="form-text text-muted formElementDesc">
              {fieldEle?.["display-description"]}
            </div>
          )}
        </div>
      </div>
    </FormGroupWrapper>
  );
};

export default CustomDate;
